import { createConfigurationApi } from "@org-avp/avp-avengers-configuration-service-api";
import { environment } from "@org-avp/avp-avengers-ui-shared-environment";
import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { prepareHeaders } from "../utils/header.utils";

const baseQueryArgs: Parameters<typeof fetchBaseQuery>[0] = {
  baseUrl: environment.NX_CONFIGURATION_SERVICE_BASE_URL,
  prepareHeaders,
};

export const configurationApi: ReturnType<typeof createConfigurationApi> = createConfigurationApi(baseQueryArgs);
